let id = 0;

export default () => id++;



// WEBPACK FOOTER //
// ./src/common/uniqueId.js